<template>
  <div class="desc-item">
    <div style="display: flex">
      <div class="order">{{ index }}</div>
      <div class="title">{{ item.title }}</div>
    </div>
    <div class="content font-14">{{ item.content }}</div>
  </div>
</template>
<script>
export default {
  name: 'desc-item',
  props: ['item', 'index'],
}
</script>
<style lang="scss" scoped>
.desc-item {
  padding: 10px 0;
  font-size: 14px;
  color: #333;
  .order {
    color: #fff;
    background-color: #29bdb9;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    text-align: center;
    margin-right: 10px;
    font-size: 9px;
    margin-top: 2px;
  }
  .title {
    font-weight: bold;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.7);
  }
  .content {
    padding-left: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tariff/bottom-desc/desc-item.vue